import { t } from './lib/i18n';

interface VisualProviderCreditProps {
  alts: Array<string | null | undefined>;
}

const usesPexels = (value: string | null | undefined): boolean =>
  Boolean(value && /(?:\bon\s+pexels\b|\bprovided\s+by\s+pexels\b)/i.test(value));

/**
 * Pexels requires a visible link back when its API content is displayed.
 * We detect direct-Pexels assets from the durable attribution text stored with
 * the visual asset, so this still works when the image bytes are cached in R2.
 */
export function VisualProviderCredit({ alts }: VisualProviderCreditProps) {
  if (!alts.some(usesPexels)) return null;
  return (
    <a
      className="visual-provider-credit"
      href="https://www.pexels.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('Photos provided by Pexels')}
    </a>
  );
}
